import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { EstruturaRetornoDadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { ServicoOutputDto } from "../domain/DTOs/output/servicos/servico.output.dto";

@Injectable()
export class ServicoJornalService {

  constructor(private baseService: BaseService) {}

  public listarServicos(): Observable<EstruturaRetornoDadosOutputDto<ServicoOutputDto[]>> {
    return this.baseService.get(`Servicos/ListarServicos`);
  }

  public obterArquivoServico(
    nomeArquivo: string
  ): Observable<EstruturaRetornoDadosOutputDto<string>> {
    return this.baseService.get(`Servicos/ObterArquivoServico?nomeArquivo=${nomeArquivo}`);
  }
}
